


























































import { HistoryTerm } from '@empathy/search-types';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { EVENTS } from '../../bus/events.const';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components
    }),
    ...mapState(SUBMODULES_PATHS.history, ['queryHistoryEnabled']),
    ...mapState(SUBMODULES_PATHS.core, ['inputQuery'])
  }
})
export default class History extends Vue {
  @Prop({ required: true })
  readonly suggestions: HistoryTerm[];

  @Prop({ required: true })
  readonly highlightedEmpathizeItem: any;

  @Prop({ default: false })
  readonly showWhenEmpty: boolean;

  @Prop({ default: EVENTS.QueryHistoryTermSelected })
  readonly event: string;

  readonly queryHistoryEnabled: boolean;
  readonly inputQuery: string;

  get toggleMessage() {
    return this.queryHistoryEnabled ?
      this.$x.messages.history.disable :
      this.$x.messages.history.enable;
  }
}
